










































import Vue from "vue";
import { EMetaGetters } from "@/services/store/meta/meta-types";
import { AUTHENTICATION_META_REGISTRATION_EMAIL } from "@/modules/authentication/constants";

export default Vue.extend({
  name: "AuthBaseSignUpSuccess",

  data() {
    return {
      currentStep: 3,

      items: [
        {
          label: this.$t("supporters.signup.steps.supporterDetails"),
          value: "supporterDetails",
        },
        {
          label: this.$t("supporters.signup.steps.supporterInterests"),
          value: "supporterInterests",
        },
        {
          label: this.$t("supporters.signup.steps.account"),
          value: "user",
        },
      ],
    };
  },

  computed: {
    registrationEmail(): string {
      return this.$store.getters[EMetaGetters.GET](
        AUTHENTICATION_META_REGISTRATION_EMAIL,
      );
    },
  },
});
